import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color"];
import React from 'react';
var Person = function Person(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.27935 12.946C2.04513 12.1802 3.08374 11.75 4.16671 11.75H10C11.083 11.75 12.1216 12.1802 12.8874 12.946C13.6532 13.7118 14.0834 14.7504 14.0834 15.8333V17.5C14.0834 17.9142 13.7476 18.25 13.3334 18.25C12.9192 18.25 12.5834 17.9142 12.5834 17.5V15.8333C12.5834 15.1482 12.3112 14.4911 11.8267 14.0066C11.3423 13.5222 10.6852 13.25 10 13.25H4.16671C3.48157 13.25 2.82448 13.5222 2.34001 14.0066C1.85555 14.4911 1.58337 15.1482 1.58337 15.8333V17.5C1.58337 17.9142 1.24759 18.25 0.833374 18.25C0.41916 18.25 0.083374 17.9142 0.083374 17.5V15.8333C0.083374 14.7504 0.513581 13.7118 1.27935 12.946Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.697 6.96967C19.9898 7.26256 19.9898 7.73744 19.697 8.03033L16.3636 11.3637C16.223 11.5043 16.0322 11.5833 15.8333 11.5833C15.6344 11.5833 15.4436 11.5043 15.303 11.3637L13.6363 9.697C13.3434 9.4041 13.3434 8.92923 13.6363 8.63634C13.9292 8.34344 14.4041 8.34344 14.697 8.63634L15.8333 9.77267L18.6363 6.96967C18.9292 6.67678 19.4041 6.67678 19.697 6.96967Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08333 3.25C5.6566 3.25 4.5 4.4066 4.5 5.83333C4.5 7.26007 5.6566 8.41667 7.08333 8.41667C8.51007 8.41667 9.66667 7.26007 9.66667 5.83333C9.66667 4.4066 8.51007 3.25 7.08333 3.25ZM3 5.83333C3 3.57817 4.82817 1.75 7.08333 1.75C9.3385 1.75 11.1667 3.57817 11.1667 5.83333C11.1667 8.0885 9.3385 9.91667 7.08333 9.91667C4.82817 9.91667 3 8.0885 3 5.83333Z",
    fill: color
  }));
};
export default Person;